var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{staticClass:"box-item",attrs:{"effect":"dark","content":"Please remove all takers configuration in this region first","disabled":!_vm.disableOption,"placement":"top"}},[_c('el-option',{attrs:{"label":_vm.region.display_name,"value":_vm.region.uid,"disabled":_vm.disableOption}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f827d9e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/FeedResources/region-option.vue
// module id = Dglo
// module chunks = 0